<template>
  <div>
    <div class="title">查&nbsp;&nbsp;询&nbsp;&nbsp;结&nbsp;&nbsp;果</div>
    <!-- 没有结果 -->
    <div class="form-box" v-if="certificates.length<1">
      <div class="no_result">对不起，没有查询到相关信息！</div>
      <div class="submit" @click="$router.back()">继&nbsp;&nbsp;续&nbsp;&nbsp;查&nbsp;&nbsp;询</div>
    </div>
    <!-- 有结果 -->
    <div class="form-box" v-else>
      <div v-for="(item,index) in certificates" :key="index">
        <div class="title-lable">基本信息</div>
        <table border="1" cellspacing="0" class="table">
          <!--个人简历-->
          <col width="255px" />
          <col width="255px" />
          <col width="255px" />
          <col width="255px" />
          <tr height="40px" align="center">
            <td class="lable">姓名:</td>
            <td>{{item.real_name}}</td>
            <td class="lable">性别:</td>
            <td>{{item.sex==1?'男':'女'}}</td>
          </tr>
          <tr height="40px" align="center">
            <td class="lable">身份证号:</td>
            <td>{{item.identity_card}}</td>
            <td></td>
            <td></td>
          </tr>
        </table>
        <div class="title-lable">证书信息</div>
        <table border="1" cellspacing="0" class="table">
          <!--个人简历-->
          <col width="255px" />
          <col width="255px" />
          <col width="255px" />
          <col width="255px" />
          <tr height="40px" align="center">
            <td class="lable">证件编号:</td>
            <td>
              <a class="link" :href="item.file">{{item.certificate_no}}</a>
            </td>
            <td class="lable">发证机构:</td>
            <td>{{item.organization_name}}</td>
          </tr>
          <tr height="40px" align="center">
            <td class="lable">发证日期:</td>
            <td>{{item.post_at}}</td>
            <td class="lable">有效期:</td>
            <td>{{item.invalid_at}}</td>
          </tr>
          <tr height="40px">
            <td class="lable">岗位:</td>
            <td colspan="3">{{item.duty_name}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      real_name: "",
      identity_card: "",
      certificate_no: "",
      certificates: [],
    };
  },
  created() {
    if (this.$route.query) {
      if (this.$route.query.identity_card) {
        this.identity_card = this.$route.query.identity_card;
      }
      if (this.$route.query.real_name) {
        this.real_name = this.$route.query.real_name;
      }
      if (this.$route.query.certificate_no) {
        this.certificate_no = this.$route.query.certificate_no;
      }
    }
    this.queryDetail();
  },
  methods: {
    queryDetail() {
      this.$http({
        url: "/api/v1/certificates/",
        method: "get",
        params: {
          identity_card: this.identity_card,
          real_name: this.real_name,
          certificate_no: this.certificate_no,
        },
      }).then((res) => {
        if (res.status == 200) {
          this.certificates = res.data.certificates;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.table {
  width: 1050px;
  margin: 0 auto;
}
.title-lable {
  width: 1050px;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  font-weight: bold;
  margin: 20px auto;
}
.lable {
  text-align: right;
  padding-right: 14px;
  font-size: 14px;
  color: #666;
}
.form-box {
  height: 600px;
  width: 100%;
  padding-top: 20px;
  background-color: #f6f6f6;
  margin-bottom: 20px;
}
.no_result {
  text-align: center;
  font-weight: bold;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
}
.link {
  color: rgba(42, 130, 228, 1);
}
.link:hover {
  color: rgba(42, 130, 228, 0.8);
}
.submit {
  width: 329px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  background-color: rgba(42, 130, 228, 1);
  font-size: 18px;
  margin: 0 auto;
  border-radius: 4px;
  margin-top: 100px;
  cursor: pointer;
}
.title {
  text-align: center;
  font-size: 16px;
  color: #000;
  height: 50px;
  line-height: 50px;
  margin-bottom: 30px;
  margin-top: 60px;
  font-weight: bold;
  background: -moz-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #000000),
    color-stop(100%, #ffffff)
  );
  background: -webkit-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -o-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -ms-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: linear-gradient(to bottom, #2a82e4 0%, #ffffff 100%);
  // background-color: rgba(42, 130, 228, 1);
}
</style>>